const PROCESS_TYPE = {
    inProgress: 'En Curso',
    notProcessed: 'No Procesado',
    pending: 'Pendiente',
    finalized: 'Finalizada'
  };
  
  export default PROCESS_TYPE;